import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lms-email-preview',
  templateUrl: './email-preview.component.html'
})
export class EmailPreviewComponent {
  public html: any;
  personalizedLegend: String;
  followUs: String;
  faq: String;
  faqHref: String;
  contact: String;
  contactHref: String;
  aboutUs: String;
  aboutUsHref: String;
  address: String;
  contactLink: String;
  constructor(private sanitizer: DomSanitizer, public translate: TranslateService) {
    this.html = localStorage.getItem('personalizedHtml');
  }
  ngOnInit() {
    this.translate.getTranslation('en').subscribe((translations) => {
      this.personalizedLegend = translations.students.bulk.PersonalizedLegend;
      this.followUs = translations.actions.followUs;
      this.faq = translations.links.faq;
      this.faqHref = translations.links.href.faq;
      this.contact = translations.links.contact;
      this.contactHref = translations.links.href.contact;
      this.aboutUs = translations.links.aboutUs;
      this.aboutUsHref = translations.links.href.aboutUs;
      this.address = translations.links.address;
      this.contactLink = translations.links.contactLink;
    });
    this.html = this.html ? this.getSanitizerHtml(this.html) : '';
  }
  getSanitizerHtml(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }
}
